import Cookies from 'js-cookie'

const cookieName = "intakeSkipWin"

export const hideWin = (win) => {
    var current = hiddenWins();
    current.push(win.trim());
    var cvalue = current.join(',');
    Cookies.set(cookieName, cvalue );

}

export const clearHiddenWins = () => {
    Cookies.remove(cookieName);
}

export const hiddenWins = function() {
    var name = cookieName;
    let value = Cookies.get(name);
    if(value == undefined){
      return [];
    }
    return value.split(",");
}





// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/hideWinCookie.js